import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";

const ProductPrice = () => {
  const { product } = useProductDetail();

  if (!product) return null;

  const hasDiscount = product.has_discount && product.list_price && product.list_price > product.price;

  return (
    <div className="pt-2 pb-4 border-b">
      {/* Crossed Price (List Price) */}
      {hasDiscount && (
        <div className="text-sm text-muted-foreground font-medium line-through mb-1">
          {product.list_price.toLocaleString("tr-TR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          {product.currency_symbol}
        </div>
      )}

      {/* Current Price with Discount Badge */}
      <div className="flex items-center gap-2">
        {/* Discount Badge - Only show if there's a discount */}
        {product.discount_percentage > 0 && (
          <div 
            className="px-2 py-1 rounded text-xs font-bold text-white"
            style={{
              backgroundColor: product.discount_background_color || "#ff9500ff",
              color: product.discount_text_color || "#FFF"
            }}
          >
            %{product.discount_percentage} İndirim
          </div>
        )}

        {/* Current Price */}
        <div className="text-2xl sm:text-3xl font-bold text-main">
          {product.price.toLocaleString("tr-TR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          {product.currency_symbol}
        </div>
      </div>
    </div>
  );
};

export default ProductPrice;